var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("tr", [
    _c(
      "td",
      { staticClass: "core-table-checkbox-col" },
      [
        _c("KCheckbox", {
          attrs: {
            label: _vm.node.title,
            showLabel: false,
            checked: _vm.checked,
            indeterminate: _vm.indeterminate,
            disabled: _vm.disabled,
          },
          on: {
            change: function ($event) {
              return _vm.$emit("changeselection", _vm.node)
            },
          },
        }),
      ],
      1
    ),
    _c(
      "td",
      { staticClass: "title" },
      [
        _c(
          "KLabeledIcon",
          {
            scopedSlots: _vm._u([
              {
                key: "icon",
                fn: function () {
                  return [_c("ContentIcon", { attrs: { kind: _vm.node.kind } })]
                },
                proxy: true,
              },
            ]),
          },
          [
            _vm.isTopic
              ? _c("KRouterLink", {
                  attrs: {
                    name: "select-node",
                    text: _vm.node.title,
                    to: _vm.getLinkObject(_vm.node),
                  },
                })
              : _c("span", { attrs: { dir: "auto" } }, [
                  _vm._v("\n        " + _vm._s(_vm.node.title) + "\n      "),
                ]),
            _c("CoachContentLabel", {
              staticClass: "coach-content-label",
              attrs: {
                value: _vm.node.num_coach_contents,
                isTopic: _vm.isTopic,
              },
            }),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "td",
      { staticClass: "message" },
      [
        _vm.message && !_vm.importing
          ? [_vm._v("\n      " + _vm._s(_vm.message) + "\n    ")]
          : _vm._e(),
        _vm.node.num_new_resources || _vm.importing
          ? _c("ChannelUpdateAnnotations", {
              staticClass: "update-label",
              attrs: {
                isTopic: _vm.isTopic,
                newResources: _vm.node.num_new_resources,
                importing: _vm.importing,
              },
            })
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }